<script lang="ts">
  import { paragraphs, parseInline } from './inline-markdown';

  interface Props {
    text: string;
    /** true なら改行ごとに <p> を分ける */
    block?: boolean;
  }

  let { text, block = false }: Props = $props();
  const paras = $derived(block ? paragraphs(text).map(parseInline) : [parseInline(text)]);
</script>

{#snippet inline(segs: ReturnType<typeof parseInline>)}
  {#each segs as seg, i (i)}
    {#if seg.kind === 'code'}<code>{seg.text}</code>{:else if seg.kind === 'strong'}<strong
        >{seg.text}</strong
      >{:else if seg.kind === 'link'}<a href={seg.href}>{seg.text}</a>{:else}{seg.text}{/if}
  {/each}
{/snippet}

{#if block}
  {#each paras as segs, i (i)}
    <p>{@render inline(segs)}</p>
  {/each}
{:else}
  {@render inline(paras[0] ?? [])}
{/if}
